const apiUrl = process.env.VITE_API_URL
const devMode = process.env.VITE_ENV_MODE === 'development'
const prodMode = process.env.VITE_ENV_MODE === 'production'
const auth0Domain = process.env.VITE_AUTH0_DOMAIN
const auth0ClientId = process.env.VITE_AUTH0_CLIENT_ID
const auth0RedirectUri = process.env.VITE_AUTH0_REDIRECT_URI
const auth0Audience = process.env.VITE_AUTH0_AUDIENCE
const posthogApiKey = process.env.VITE_POSTHOG_API_KEY
const posthogApiHost = process.env.VITE_POSTHOG_API_HOST
const isLocalhost =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

export {
  apiUrl,
  devMode,
  prodMode,
  auth0Domain,
  auth0ClientId,
  auth0RedirectUri,
  auth0Audience,
  posthogApiKey,
  posthogApiHost,
  isLocalhost,
}
